/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState, useRef } from "react";
import "./styles.css";
import "../../../../../src/datepicker-custom.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { format, formatDate } from "date-fns";
import { Context } from "../../../../hooks/useAuthContext";
import api from "../../../../services/axiosConfig";
import { Alert, Table } from "reactstrap";
import { formatarMoeda } from "../../../../utils/formatMoeda";
import ModalLinks from "./components/ModalLinks/ModalLinks";
import ModalChavesPix from "../../../../components/ModalChavesPix/ModalChavesPix";
import Swal from "sweetalert2";
import Pendente from "./components/Notifications/Pendente";
import { Link, useNavigate } from "react-router-dom";
import ComunicadoAlerta from "../../../../components/ComunicadoAlerta/ComunicadoAlerta";
import { getDataDoismesesAtras } from "../../../../utils/doismeses";

function AfiliadoDashboard() {
  const { userData, exibirLogs, logout, buscarNotasFiscaisPorMes } =
    useContext(Context);
  const navigate = useNavigate();

  const idAfiliado = userData?.afiliadoConfig?.idAfiliado;

  const CACHE_KEY = "consultaUpload";
  const CACHE_DURATION_MS = 5 * 60 * 1000;

  const [receiptDataPeriod, setReceiptDataPeriod] = useState({});
  const [convertedValuePeriod, setConvertedValuePeriod] = useState(0);
  const [convertedValueLiquid, setConvertedValueLiquid] = useState(0);
  const [selectedDatePeriod, setSelectedDatePeriod] = useState(new Date());

  const [, setIsMobile] = useState(window.innerWidth < 768);
  const [modalAberto, setModalAberto] = useState(false);
  const [modalChavePixAberto, setModalChavePixAberto] = useState(false);
  const [dataInfo, setDataInfo] = useState(null);
  const [notas, setNotas] = useState([]);
  const [data, setData] = useState("");
  const [afiliados, setAfiliados] = useState([]);
  const [receitasUsuarios, setReceitasUsuarios] = useState({});
  const [canDisplayFiscalAlerts, setCanDisplayFiscalAlerts] = useState(true);

  const alertShownRef = useRef(false);

  useEffect(() => {
    if (userData) {
      const canAccess = !!userData.afiliadoConfig || userData.tipoConta === 'afiliado';
      if (!canAccess) {
        navigate("/");
      }
    }
  }, [userData, navigate]);

  function handleLogout() {
    logout();
    Swal.close();
  }

  useEffect(() => {
    if (selectedDatePeriod) {
      setData(getDataDoismesesAtras(selectedDatePeriod));
    }
  }, [selectedDatePeriod]);

  useEffect(() => {
    if (!data || !userData?.uid) {
      return;
    }
    async function fetchNotas() {
      try {
        const dataParaBusca = getDataDoismesesAtras(selectedDatePeriod);
        const todasAsNotas = await buscarNotasFiscaisPorMes(userData.uid, dataParaBusca);
        const notasComissao = todasAsNotas.filter(nota => nota.tipoNota === 'comissao');
        setNotas(notasComissao || []);
      } catch (err) {
        exibirLogs && console.error("Erro ao buscar notas de comissão:", err);
        setNotas([]);
      }
    }
    fetchNotas();
  }, [data, buscarNotasFiscaisPorMes, userData?.uid, selectedDatePeriod, exibirLogs]);

  useEffect(() => {
    if (userData.status === "inativo") {
      Swal.fire({
        icon: "error",
        title: userData.motivoRejeicao.titulo,
        text: userData.motivoRejeicao.descricao,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        backdrop: "rgba(0, 0, 0, 1)",
        footer:
          '<div style="display: flex; gap: 10px; width: 100%;">' +
          '<button id="logout-btn" style="background: #dc3545; color: #fff; border: none; padding: 10px; border-radius: 4px; width: 100%; cursor: pointer;">Desconectar da sua conta</button>' +
          '<a id="chamado-link" href="/abrir-chamado?assunto=inativo" style="background: #6c757d; color: #fff; display: block; text-align: center; padding: 10px; border-radius: 4px; text-decoration: none; width: 100%;">Abrir chamado</a>' +
          "</div>",
        didOpen: () => {
          document
            .getElementById("logout-btn")
            .addEventListener("click", handleLogout);
          const chamadoLink = document.getElementById("chamado-link");
          chamadoLink.addEventListener("click", (event) => {
            event.preventDefault();
            Swal.close();
            navigate("/abrir-chamado?assunto=inativo");
          });
        },
      });
    }
  }, [userData, logout, navigate]);

  const getUserReceiptPeriod = async () => {
    if (!idAfiliado) return;
    const dateNf = new Date(selectedDatePeriod);
    dateNf.setMonth(dateNf.getMonth() - 2);
    try {
      const response = await api.post(
        "/users/dashboard/receita-afiliado-periodo",
        {
          date: formatDate(dateNf, "MM/yyyy"),
          idAfiliado: idAfiliado,
          porcentagem: userData.afiliadoConfig?.porcentagem,
          tipoConta: userData.tipoConta,
        }
      );
      setConvertedValuePeriod(response.data?.totalValorEmRealComDesconto);
      setConvertedValueLiquid(response.data?.suaParte);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar valores de comissão: ", error);
    }
  };

  const getReceiptAfiliado = async (uid) => {
    const dateNf = new Date(selectedDatePeriod);
    dateNf.setMonth(dateNf.getMonth() - 2);
    try {
      const response = await api.post("/nf/notas-data", {
        date: formatDate(dateNf, "MM/yyyy"),
        uid,
      });
      const notaNormalDoMembro = response.data.find(n => n.tipoNota === 'normal');
      return notaNormalDoMembro?.values.valorEmRealComDesconto || 0;
    } catch (error) {
      exibirLogs &&
        console.error(`Erro ao buscar valores para o UID ${uid}: `, error);
      return 0;
    }
  };

  const fetchUltimoUpload = async () => {
    try {
      const response = await api.get("/users/dashboard/ultimo-upload");
      const data = response.data[0];
      const now = Date.now();
      const cacheData = {
        dataConsulta: now,
        dataInfo: new Date(data.atualizadoEm).getTime(),
      };
      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
      setDataInfo(cacheData.dataInfo);
    } catch (error) {
      console.error("Erro ao buscar último upload:", error);
    }
  };

  useEffect(() => {
    const cache = localStorage.getItem(CACHE_KEY);
    if (cache) {
      const { dataConsulta, dataInfo } = JSON.parse(cache);
      const agora = Date.now();
      if (agora - dataConsulta < CACHE_DURATION_MS) {
        setDataInfo(dataInfo);
        return;
      } else {
        localStorage.removeItem(CACHE_KEY);
      }
    }
    fetchUltimoUpload();
  }, []);

  useEffect(() => {
    getUserReceiptPeriod();
  }, [selectedDatePeriod, idAfiliado, userData]);

  const showLinks = () => {
    setModalAberto(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const precisaCadastrarChavePix =
      !userData?.chavesPix || userData?.chavesPix?.length === 0;
    if (precisaCadastrarChavePix) {
      setModalChavePixAberto(true);
    }
  }, [userData]);

  useEffect(() => {
    if (
      userData?.chavesPix &&
      (userData?.tipoConta === "usuario" ||
        userData?.tipoConta === "influenciador")
    ) {
      const precisaCadastrarDocs =
        !userData?.documentoFrente || !userData?.documentoVerso;
      if (precisaCadastrarDocs) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "Parece que você não tem seus documentos.",
          footer:
            '<a href="/atualizar-dados?action=upload">Adicionar documentos</a>',
        });
      }
    }
  }, [userData]);

  useEffect(() => {
    const fetchAfiliados = async () => {
      if (idAfiliado) {
        try {
          const response = await api.post("/auth/user/afiliadoRef", {
            afiliadoRef: idAfiliado,
          });
          const listaAfiliados = response.data.data || [];
          setAfiliados(listaAfiliados);
          if (listaAfiliados.length > 0) {
            const receitas = {};
            const porcentagemComissao = (userData.afiliadoConfig?.porcentagem || 0) / 100;
            for (const afiliado of listaAfiliados) {
              const valorBase = await getReceiptAfiliado(afiliado._id);
              receitas[afiliado._id] = valorBase * porcentagemComissao;
            }
            setReceitasUsuarios(receitas);
          }
        } catch (error) {
          exibirLogs && console.error("Erro ao buscar afiliados:", error);
        }
      }
    };
    fetchAfiliados();
  }, [userData, exibirLogs, selectedDatePeriod, idAfiliado]);

  function isCurrentDayBeforeTenth() {
    const today = new Date();
    return today.getDate() < 10;
  }

  function isCurrentDayFromTenthOnwards() {
    const today = new Date();
    return today.getDate() >= 10;
  }

  const triggerAlert = useCallback(
    async (alertData, options = {}) => {
      if (alertShownRef.current || !alertData) {
        return;
      }

      let alertTitle;
      let alertText;
      let formattedNotaDate;

      if (alertData.status === "nao_enviada") {
        alertTitle = `Nota de ${alertData.date} não enviada!`;
        alertText = `Você ainda não emitiu a nota fiscal referente a ${alertData.date}. Por favor, realize a emissão para evitar problemas.`;
      } else {
        const nota = alertData;
        if (nota.date) {
          if (
            typeof nota.date === "string" &&
            nota.date.match(/^\d{2}\/\d{4}$/)
          ) {
            formattedNotaDate = nota.date;
          } else {
            const parsedDate = new Date(nota.date);
            if (!isNaN(parsedDate.getTime())) {
              formattedNotaDate = format(parsedDate, "MM/yyyy", {
                locale: ptBR,
              });
            } else {
              formattedNotaDate = "data inválida";
            }
          }
        } else {
          formattedNotaDate = "data desconhecida";
        }

        if (nota?.status === "cancelado") {
          alertTitle = `Nota de ${formattedNotaDate} cancelada!`;
          alertText =
            nota.motivoCancelamento || nota.motivoCancelamento !== ""
              ? nota.motivoCancelamento
              : `A sua nota fiscal de ${formattedNotaDate} foi cancelada.`;
        } else if (nota.status === "pendente") {
          alertTitle = `Nota de ${formattedNotaDate} pendente!`;
          alertText = `Sua nota fiscal de ${formattedNotaDate} ainda está com o status pendente. Por favor, verifique.`;
        } else {
          return;
        }
      }

      alertShownRef.current = true;

      const swalOptions = {
        title: alertTitle,
        text: alertText,
        icon: "warning",
        backdrop: "rgba(0, 0, 0, 1)",
        confirmButtonText: "Resolver Pendência",
        ...options,
      };

      const result = await Swal.fire(swalOptions);

      if (result.isConfirmed) {
        navigate("/emitir-nota-fiscal?tipo=comissao");
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (!notas || !Array.isArray(notas)) {
      return;
    }

    const travarAbril = true;

    if (travarAbril) {
      const checkDate = new Date();
      checkDate.setMonth(checkDate.getMonth() - 2);
      const targetMonth = checkDate.getMonth();
      const targetYear = checkDate.getFullYear();

      if (targetMonth === 3 && targetYear === 2025) {
        exibirLogs &&
          console.log(
            "Exceção de alerta: Período de referência é Abril de 2025. Alertas desativados."
          );
        setCanDisplayFiscalAlerts(false);
        return;
      }
    } else {
      exibirLogs && console.log("Abril não liberado para emissão de nota");
    }

    alertShownRef.current = false;
    setCanDisplayFiscalAlerts(true);

    const notaCancelada = notas.find((n) => n.status === "cancelado");
    const notaPendente = notas.find((n) => n.status === "pendente");

    if (isCurrentDayBeforeTenth()) {
      if (notaCancelada) {
        triggerAlert(notaCancelada, {
          allowOutsideClick: true,
          allowEscapeKey: true,
          showCancelButton: true,
          cancelButtonText: "Fechar",
        });
      } else if (notaPendente) {
        triggerAlert(notaPendente, {
          allowOutsideClick: true,
          allowEscapeKey: true,
          showCancelButton: true,
          cancelButtonText: "Fechar",
        });
      }
    } else if (isCurrentDayFromTenthOnwards()) {
      const nonClosableOptions = {
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
      };

      if (notaCancelada) {
        triggerAlert(notaCancelada, nonClosableOptions);
      } else if (notaPendente) {
        triggerAlert(notaPendente, nonClosableOptions);
      }
    }
  }, [notas, triggerAlert, exibirLogs]);

  const notaPendente = notas?.find((nota) => nota.status === "pendente");

  return (
    <div className="receitaContainer">
      <h2 style={{ color: 'white', fontWeight: 'bold'}}>Dash de Afiliado</h2>
      {!userData?.acceptedTerm && <ComunicadoAlerta />}

      {canDisplayFiscalAlerts && notaPendente && (
        <Link
          to={`/emitir-nota-fiscal?tipo=comissao&data=${selectedDatePeriod.toISOString()}`}
          style={{ textDecoration: "none" }}
        >
          <Pendente />
        </Link>
      )}

      {dataInfo && (
        <Alert
          style={{ backgroundColor: "#3C3C3C", color: "#FFF", border: "none" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Última atualização:</span>{" "}
            <span>{new Date(dataInfo).toLocaleString()}</span>
          </div>
        </Alert>
      )}

      {receiptDataPeriod ? (
        <div className="card whiteCard" style={{ marginTop: 20 }}>
          <h3 className="cardTitle">Receita por Mês</h3>
          <DatePicker
            selected={selectedDatePeriod}
            onChange={(date) => setSelectedDatePeriod(date)}
            dateFormat="MM/yyyy"
            className="dateInput"
            showMonthYearPicker
            showFullMonthYearPicker
          />

          <br />

          {userData.tipoConta !== "administrador" && (
            <div className="infoBlock">
              <p className="infoTitle">Comissão referente ao mês {data}</p>
              <div className="valueGroup">
                <span className="valueMain green">
                  R$ {formatarMoeda(convertedValueLiquid)}
                </span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>Carregando...</div>
      )}

      <button className="btnLinks" onClick={showLinks}>
        Meu Link de Afiliado
      </button>

      <div className="listUtms" style={{ marginTop: 20 }}>
        <div style={{ marginBottom: 15, color: "#fff" }}>
          <strong>Meus Afiliados</strong>
        </div>
        <Table striped className="table-dark" responsive style={{ tableLayout: "auto" }}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Comissão</th>
            </tr>
          </thead>
          <tbody>
            {afiliados.length > 0 ? (
              afiliados.map((afiliado) => (
                <tr key={afiliado._id}>
                  <td>{afiliado.nome}</td>
                  <td>R$ {formatarMoeda(receitasUsuarios[afiliado._id] || 0)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-center">
                  Você ainda não possui afiliados.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <ModalLinks
        isOpen={modalAberto}
        toggle={() => setModalAberto(!modalAberto)}
        afiliado={idAfiliado}
      />

      <ModalChavesPix
        isOpen={modalChavePixAberto}
        onClose={() => setModalChavePixAberto(false)}
      />
    </div>
  );
}

export default AfiliadoDashboard;